import { MessagingHelper } from "../helpers/MessagingHelper";
import { PaginatedList } from "../helpers/PaginatedList";
import { ICountryDTO } from "../models/Country/ICountryDTO";
import { ICountryCreateDTO } from "../models/Country/ICountryCreateDTO";
import { ICountryUpdateDTO } from "../models/Country/ICountryUpdateDTO";
import { APIService } from "./APIService";
import { Parameter } from "../models/Parameter";

export class CountryService {
  async GetCountryById(
    id: number
  ): Promise<MessagingHelper<ICountryDTO | null>> {
    try {
      var response = await APIService.Axios().get(
        `${APIService.GetURL()}/Country/${id}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(false, "Erro ao encontrar país", null);
    }
  }
  async SearchCountryByName(
    nameCountry: string
  ): Promise<MessagingHelper<ICountryDTO[] | null>> {
    try {
      var response = await APIService.Axios().get(
        `${APIService.GetURL()}/Country/SearchByCountry`,
        {
          params: {
            nameCountry,
          },
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(false, "Erro ao encontrar país", null);
    }
  }
  async GetAll(
    searchParameters: Parameter[],
    sortingParameters: Parameter[],
    currentPage: number,
    pageSize: number
  ): Promise<PaginatedList<ICountryDTO>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Country/GetAll`,
        {
          searchParameters,
          sortingParameters,
          currentPage,
          pageSize,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new PaginatedList<ICountryDTO>(
        false,
        "Erro ao obter a informação dos países",
        "",
        [],
        0
      );
    }
  }

  async Create(
    createCountry: ICountryCreateDTO
  ): Promise<MessagingHelper<string>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Country/Create`,
        {
          ...createCountry,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<string>(
        false,
        "Erro ao ligar ao servidor para criar o país",
        ""
      );
    }
  }

  async Edit(
    countryUpdate: ICountryUpdateDTO
  ): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Country/Edit`,
        { ...countryUpdate },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao ligar ao servidor para atualizar o país",
        null
      );
    }
  }
}
